import axios from "axios"

async function addToCart(offerID, links, initialQuantities = null) {
    const dataToSend = new URLSearchParams();
    dataToSend.append("action", "woocommerce_ajax_add_to_cart_offerwall");
    dataToSend.append("offerID", offerID);
    dataToSend.append("links", Array.isArray(links) ? links.join(",") : links);
    if(initialQuantities){
        dataToSend.append("initialQuantities",  initialQuantities ? (Array.isArray(initialQuantities)? initialQuantities.join(",") : initialQuantities) : 'unavailable');
    }
    // eslint-disable-next-line no-undef 
    return axios.post(wc_add_to_cart_params.ajax_url, dataToSend, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    //wc_add_to_cart_params.ajax_url
}

export { addToCart }